import API_ENDPOINTS from "app/config/endpoints";
import { schoolTokenAxios, authTokenAxios } from "../axios";

// collection
export const editCollectionHeadLogic = (payload) => {
  return schoolTokenAxios.put(
    `${API_ENDPOINTS.ledgerAccount.editCollectionHead}`,
    payload,
  );
};
export const addCollectionHeadLogic = (payload) => {
  return schoolTokenAxios.post(
    `${API_ENDPOINTS.ledgerAccount.addCollectionHead}`,
    payload,
  );
};
export const getAllCollectionHead = (payload) => {
  return schoolTokenAxios.get(
    `${API_ENDPOINTS.ledgerAccount.getAllCollectionHead}`,
  );
};

export const getAllCollectionSubHead = (params) => {
  return schoolTokenAxios.get(
    `${API_ENDPOINTS.ledgerAccount.getAllCollectionSubHead}`,
    {
      params: {
        ...params,
      },
    },
  );
};

export const getAllCollectionLogic = (payload) => {
  return schoolTokenAxios.get(
    `${API_ENDPOINTS.ledgerAccount.getAllCollection}?from=${payload.from}&to=${payload.to}&status=ACTIVE`,
  );
};
export const addCollectionLogic = (payload) => {
  return schoolTokenAxios.post(
    `${API_ENDPOINTS.ledgerAccount.addCollection}`,
    payload,
  );
};
export const deleteCollectionLogic = (payload) => {
  return schoolTokenAxios.delete(
    `${API_ENDPOINTS.ledgerAccount.deleteCollection}/${payload}`,
  );
};

// Expense
export const editExpenseHeadLogic = (payload) => {
  return schoolTokenAxios.put(
    `${API_ENDPOINTS.ledgerAccount.editExpenseHead}`,
    payload,
  );
};
export const addExpenseHeadLogic = (payload) => {
  return schoolTokenAxios.post(
    `${API_ENDPOINTS.ledgerAccount.addExpenseHead}`,
    payload,
  );
};
export const getAllExpenseHead = (params) => {
  return schoolTokenAxios.get(
    `${API_ENDPOINTS.ledgerAccount.getAllExpenseHead}`,
    {
      params: {
        ...params,
      },
    },
  );
};

export const getAllExpenseSubHead = (params) => {
  return schoolTokenAxios.get(
    `${API_ENDPOINTS.ledgerAccount.getAllExpenseSubHead}`,
    {
      params: {
        ...params,
      },
    },
  );
};

export const getAllExpenseLogic = (payload) => {
  return schoolTokenAxios.get(
    `${API_ENDPOINTS.ledgerAccount.getAllExpense}?from=${payload.from}&to=${payload.to}&status=ACTIVE`,
  );
};
export const addExpenseLogic = (payload) => {
  return schoolTokenAxios.post(
    `${API_ENDPOINTS.ledgerAccount.addExpense}`,
    payload,
  );
};
export const deleteExpenseLogic = (payload) => {
  return schoolTokenAxios.delete(
    `${API_ENDPOINTS.ledgerAccount.deleteExpense}/${payload}`,
  );
};

export const changePasswordWithoutOtp = (payload) => {
  return authTokenAxios.put(
    `${API_ENDPOINTS.auth.changePasswordWithoutOtp}`,
    payload,
  );
};

export const getInternalTransfer = (query) => {
  return schoolTokenAxios.get(
    `${API_ENDPOINTS.ledgerAccount.getInternalTransfer}`,
    {
      params: {
        ...query,
      },
    },
  );
};

export const addInternalTransfer = (data) => {
  return schoolTokenAxios.post(
    `${API_ENDPOINTS.ledgerAccount.addInternalTransfer}`,
    data,
  );
};

export const updateStatusInternalTransfer = (data) => {
  return schoolTokenAxios.put(
    `${API_ENDPOINTS.ledgerAccount.updateStatusInternalTransfer}`,
    data,
  );
};

export const deleteInternalTransfer = (id) => {
  return schoolTokenAxios.delete(
    `${API_ENDPOINTS.ledgerAccount.deleteInternalTransfer}/${id}`,
  );
};
export const deleteCollectionHead = (id) => {
  return schoolTokenAxios.delete(
    `${API_ENDPOINTS.ledgerAccount.deleteCollectionHead}/${id}`,
  );
};
export const deleteCollectionSubHead = (id) => {
  return schoolTokenAxios.delete(
    `${API_ENDPOINTS.ledgerAccount.deleteCollectionSubHead}/${id}`,
  );
};
export const deleteExpenseHead = (id) => {
  return schoolTokenAxios.delete(
    `${API_ENDPOINTS.ledgerAccount.deleteExpenseHead}/${id}`,
  );
};
export const deleteExpenseSubHead = (id) => {
  return schoolTokenAxios.delete(
    `${API_ENDPOINTS.ledgerAccount.deleteExpenseSubHead}/${id}`,
  );
};
export const deleteUtilityInvoice = (id) => {
  return schoolTokenAxios.delete(
    `${API_ENDPOINTS.ledgerAccount.deleteUtilityInvoice}/${id}`,
  );
};

export const getBookSellerNames = () => {
  return schoolTokenAxios.get(
    `${API_ENDPOINTS.ledgerAccount.getBookSellerNames}`,
  );
};

export const addNewBookSeller = (data) => {
  return schoolTokenAxios.post(
    `${API_ENDPOINTS.ledgerAccount.addNewBookSeller}`,
    data,
  );
};

export const getUniformSellerNames = () => {
  return schoolTokenAxios.get(
    `${API_ENDPOINTS.ledgerAccount.getUniformSellerNames}`,
  );
};

export const addNewUniformSeller = (data) => {
  return schoolTokenAxios.post(
    `${API_ENDPOINTS.ledgerAccount.addNewUniformSeller}`,
    data,
  );
};
export const updateBookQuantity = (data) => {
  return schoolTokenAxios.put(
    `${API_ENDPOINTS.ledgerAccount.updateBookQuantity}`,
    data,
  );
};

export const getBooksForSale = (params) => {
  return schoolTokenAxios.get(
    `${API_ENDPOINTS.ledgerAccount.getBooksForSale}`,
    {
      params: {
        ...params,
      },
    },
  );
};
export const deleteBook = (bookDocId) => {
  return schoolTokenAxios.delete(
    `${API_ENDPOINTS.ledgerAccount.deleteBook}/${bookDocId}`,
  );
};
export const getSingleBooksForSale = (params) => {
  return schoolTokenAxios.get(
    `${API_ENDPOINTS.ledgerAccount.getBooksForSale}`,
    {
      params: {
        ...params,
      },
    },
  );
};

export const getSoldBook = (params) => {
  return schoolTokenAxios.get(`${API_ENDPOINTS.ledgerAccount.getSoldBook}`, {
    params: {
      ...params,
    },
  });
};

export const addBookExpenseDetail = (data) => {
  return schoolTokenAxios.post(
    `${API_ENDPOINTS.ledgerAccount.addBookExpenseDetail}`,
    data,
  );
};
export const updateBookRate = (data) => {
  return schoolTokenAxios.put(
    `${API_ENDPOINTS.ledgerAccount.updateBookRate}`,
    data,
  );
};

export const getBookGroup = (params) => {
  return schoolTokenAxios.get(`${API_ENDPOINTS.ledgerAccount.getBookGroup}`, {
    params: {
      ...params,
    },
  });
};

export const getTransactionDetail = (params) => {
  return schoolTokenAxios.get(
    `${API_ENDPOINTS.ledgerAccount.getTransactionByFirstInvoiceNo}`,
    {
      params: {
        ...params,
      },
    },
  );
};

export const payInstallment = (data) => {
  return schoolTokenAxios.post(
    `${API_ENDPOINTS.ledgerAccount.payInstallment}`,
    data,
  );
};

export const addBookGroup = (data) => {
  return schoolTokenAxios.post(
    `${API_ENDPOINTS.ledgerAccount.addBookGroup}`,
    data,
  );
};

export const getUtilityInvoice = (params) => {
  return schoolTokenAxios.get(
    `${API_ENDPOINTS.ledgerAccount.getUtilityInvoice}`,
    {
      params: {
        ...params,
      },
    },
  );
};

export const saleBook = (data) => {
  return schoolTokenAxios.post(`${API_ENDPOINTS.ledgerAccount.saleBook}`, data);
};

// Uniform (preferred)
export const getUniformItems = (params) => {
  return schoolTokenAxios.get(
    `${API_ENDPOINTS.ledgerAccount.getUniformItems}`,
    {
      params: { ...params },
    },
  );
};
export const addUniformItem = (data) => {
  return schoolTokenAxios.post(
    `${API_ENDPOINTS.ledgerAccount.addUniformItem}`,
    data,
  );
};
export const updateUniformItem = (data) => {
  return schoolTokenAxios.put(
    `${API_ENDPOINTS.ledgerAccount.updateUniformItem}`,
    data,
  );
};
export const deleteUniformItem = (id) => {
  return schoolTokenAxios.delete(
    `${API_ENDPOINTS.ledgerAccount.deleteUniformItem}/${id}`,
  );
};

export const addUniformItemSize = (data) => {
  return schoolTokenAxios.post(
    `${API_ENDPOINTS.ledgerAccount.addUniformItemSize}`,
    data,
  );
};

export const getUniformItemSizes = (params) => {
  return schoolTokenAxios.get(
    `${API_ENDPOINTS.ledgerAccount.getUniformItemSizes}`,
    { params: { ...params } },
  );
};

export const updateUniformItemSize = (data) => {
  return schoolTokenAxios.put(
    `${API_ENDPOINTS.ledgerAccount.updateUniformItemSize}`,
    data,
  );
};

export const deleteUniformItemSize = ({ uniformItemDocId, size }) => {
  return schoolTokenAxios.delete(
    `${API_ENDPOINTS.ledgerAccount.deleteUniformItemSize}`,
    { params: { uniformItemDocId, size } },
  );
};

export const buyUniformStock = (data) => {
  return schoolTokenAxios.post(
    `${API_ENDPOINTS.ledgerAccount.buyUniformStock}`,
    data,
  );
};

export const purchaseUniformStock = (data) => {
  return schoolTokenAxios.post(
    `${API_ENDPOINTS.ledgerAccount.purchaseUniformStock}`,
    data,
  );
};

export const getUniformStockSummary = (params) => {
  return schoolTokenAxios.get(
    `${API_ENDPOINTS.ledgerAccount.getUniformStockSummary}`,
    { params: { ...params } },
  );
};

export const deleteUniformStock = (uniformStockDocId) => {
  return schoolTokenAxios.delete(
    `${API_ENDPOINTS.ledgerAccount.deleteUniformStock}/${uniformStockDocId}`,
  );
};

export const saleUniform = (data) => {
  return schoolTokenAxios.post(
    `${API_ENDPOINTS.ledgerAccount.saleUniform}`,
    data,
  );
};
export const getSoldUniform = (params) => {
  return schoolTokenAxios.get(`${API_ENDPOINTS.ledgerAccount.getSoldUniform}`, {
    params: { ...params },
  });
};

export const getUniformNonPurchasedStudents = (params) => {
  return schoolTokenAxios.get(
    `${API_ENDPOINTS.ledgerAccount.getUniformNonPurchasedStudents}`,
    { params: { ...params } },
  );
};
export const getUniformTransactionByFirstInvoice = (params) => {
  return schoolTokenAxios.get(
    `${API_ENDPOINTS.ledgerAccount.getUniformTransactionByFirstInvoice}`,
    { params: { ...params } },
  );
};
export const payUniformInstallment = (data) => {
  return schoolTokenAxios.post(
    `${API_ENDPOINTS.ledgerAccount.payUniformInstallment}`,
    data,
  );
};

// Uniform Sets
export const getUniformSets = (params) => {
  return schoolTokenAxios.get(`${API_ENDPOINTS.ledgerAccount.getUniformSets}`, {
    params: { ...params },
  });
};
export const addUniformSet = (data) => {
  return schoolTokenAxios.post(`${API_ENDPOINTS.ledgerAccount.addUniformSet}`, data);
};
export const updateUniformSet = (data) => {
  return schoolTokenAxios.put(`${API_ENDPOINTS.ledgerAccount.updateUniformSet}`, data);
};
export const deleteUniformSet = (id) => {
  return schoolTokenAxios.delete(`${API_ENDPOINTS.ledgerAccount.deleteUniformSet}/${id}`);
};

export const getUniformInvoice = (params) => {
  return schoolTokenAxios.get(`${API_ENDPOINTS.ledgerAccount.getUniformInvoice}`, {
    params: { ...params },
  });
};

export const getAllCollection = (params) => {
  return schoolTokenAxios.get(
    `${API_ENDPOINTS.ledgerAccount.getAllCollection}`,
    {
      params: {
        ...params,
      },
    },
  );
};
export const deleteCollection = (id) => {
  return schoolTokenAxios.delete(
    `${API_ENDPOINTS.ledgerAccount.deleteCollection}/${id}`,
  );
};

export const addCollectionDetail = (data) => {
  return schoolTokenAxios.post(
    `${API_ENDPOINTS.ledgerAccount.addCollectionDetail}`,
    data,
  );
};

export const getAllExpense = (params) => {
  return schoolTokenAxios.get(`${API_ENDPOINTS.ledgerAccount.getAllExpense}`, {
    params: {
      ...params,
    },
  });
};
export const getAllExpenseByDocId = (params) => {
  return schoolTokenAxios.get(`${API_ENDPOINTS.ledgerAccount.getAllExpense}`, {
    params,
  });
};

export const requestExpense = (data) => {
  return schoolTokenAxios.post(
    `${API_ENDPOINTS.ledgerAccount.requestExpense}`,
    data,
  );
};

export const rejectExpense = (id) => {
  return schoolTokenAxios.put(
    `${API_ENDPOINTS.ledgerAccount.rejectExpense}/${id}`,
  );
};

export const approveExpense = (data) => {
  return schoolTokenAxios.put(
    `${API_ENDPOINTS.ledgerAccount.approveExpense}`,
    data,
  );
};

export const payExpense = (data) => {
  return schoolTokenAxios.put(
    `${API_ENDPOINTS.ledgerAccount.payExpense}`,
    data,
  );
};

export const addCompletedExpenseDetail = (data) => {
  return schoolTokenAxios.post(
    `${API_ENDPOINTS.ledgerAccount.addCompletedExpenseDetail}`,
    data,
  );
};

export const deleteExpense = (id) => {
  return schoolTokenAxios.delete(
    `${API_ENDPOINTS.ledgerAccount.delExpense}/${id}`,
  );
};

export const verifyPaidExpense = (id) => {
  return schoolTokenAxios.put(
    `${API_ENDPOINTS.ledgerAccount.verifyPaidExpense}/${id}`,
  );
};

export const addCollectionSubHead = (data) => {
  return schoolTokenAxios.post(
    `${API_ENDPOINTS.ledgerAccount.addCollectionSubHead}`,
    data,
  );
};

export const addExpenseSubHead = (data) => {
  return schoolTokenAxios.post(
    `${API_ENDPOINTS.ledgerAccount.addExpenseSubHead}`,
    data,
  );
};
